import { Form, FormDate, FormInput, FormSwitch } from 'metrix-common3';
import { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';

const ProfileTestMode = (props) => {
    const { policyTestOverride, context } = props;
    const culture = context?.session?.culture;
    const isCertificate = policyTestOverride?.isCertificate || false;
    const isTestModeEnabled = policyTestOverride?.isTestModeEnabled || false;

    const [isPolicyInTestMode, setIsPolicyInTestMode] = useState(false);
    const [goFirmDateTest, setGoFirmDateTest] = useState(null);

    // biome-ignore lint/correctness/useExhaustiveDependencies: mount-only init
    useEffect(() => {
        props.doGetPolicyTestOverride();
    }, []);

    useEffect(() => {
        if (policyTestOverride) {
            setIsPolicyInTestMode(policyTestOverride.isPolicyInTestMode || false);
            setGoFirmDateTest(policyTestOverride.goFirmDateTest);
        }
    }, [policyTestOverride]);

    const handleSave = () => {
        props.doSetPolicyTestOverride({
            isPolicyInTestMode,
            goFirmDateTest,
        });
    };

    const handleCancel = () => {
        setIsPolicyInTestMode(policyTestOverride?.isPolicyInTestMode || false);
        setGoFirmDateTest(policyTestOverride?.goFirmDateTest);
    };

    return (
        <Form
            pageCode='testMode'
            sectionCode='policyTestOverride'
            header={<FormattedMessage id='Profile_TestMode.title' defaultMessage='Test Mode' />}
            label={
                isTestModeEnabled ? (
                    <FormattedMessage id='Profile_TestMode.description' defaultMessage='Override dates for testing' />
                ) : (
                    <FormattedMessage
                        id='Profile_TestMode.descriptionDisabled'
                        defaultMessage='Test mode is disabled globally'
                    />
                )
            }
            saveEvent={handleSave}
            cancelEvent={handleCancel}
            allowEdit={isTestModeEnabled}
        >
            <FormSwitch
                fieldCode='isPolicyInTestMode'
                label={
                    <FormattedMessage
                        id='Profile_TestMode.isPolicyInTestModeLabel'
                        defaultMessage='Enable Test Mode for this Policy'
                    />
                }
                value={isPolicyInTestMode}
                changeEvent={(value) => setIsPolicyInTestMode(value)}
                allowEdit={isTestModeEnabled}
            />
            {!isCertificate && (
                <FormInput
                    fieldCode='goFirmDate'
                    label={<FormattedMessage id='Profile_TestMode.realGoFirmDate' defaultMessage='GoFirmDate' />}
                    value={policyTestOverride?.goFirmDate ? policyTestOverride.goFirmDate.substring(0, 10) : ''}
                    // biome-ignore lint/suspicious/noEmptyBlockStatements: noop callback for changeEvent contract (read-only field)
                    changeEvent={() => {}}
                    allowEdit={false}
                />
            )}
            {!isCertificate && (
                <FormDate
                    fieldCode='goFirmDateTest'
                    label={
                        <FormattedMessage id='Profile_TestMode.goFirmDateTestLabel' defaultMessage='GoFirmDate Test' />
                    }
                    value={goFirmDateTest}
                    changeEvent={(value) => setGoFirmDateTest(value)}
                    culture={culture}
                    allowEdit={isTestModeEnabled}
                />
            )}
        </Form>
    );
};

export default ProfileTestMode;
